import { TenantConfig } from './tenant-config.model';

// Static tenant registry, resolved by subdomain (see resolveTenantId /
// TenantService). 'mindfield' is DEFAULT_TENANT_ID: the fallback for the
// apex domain and any hostname that doesn't match a configured subdomain.
export const TENANTS: { [id: string]: TenantConfig } = {
  mindfield: {
    id: 'mindfield',
    subdomain: 'www',
    deviceName: 'eSense eGenius',
    primaryColor: '#17214b',
    features: {
      mindfieldConnect: true,
      testing: true,
      invoicing: true,
      statistics: true,
      news: true,
      personalCoachingBanner: true,
      faq: true,
      chatTemplates: true,
      mindfieldBranding: true,
      aiAssistant: true,
    },
    support: {
      defaultSupervisorId: '359352',
      defaultSuperUserProfile: {
        id: '18212744',
        name: 'Mindfield',
        displayName: 'Mindfield',
        email: 'info@mindfield-biosystems.com',
      },
    },
  },
  feelen: {
    id: 'feelen',
    subdomain: 'feelen',
    deviceName: 'feelGenius',
    // Turquoise-to-teal gradient from the Feelen styleguide (CD Styleguide feelen_2025, p.2).
    primaryColor: '#007f79',
    primaryColorEnd: '#00d890',
    features: {
      mindfieldConnect: false,
      testing: false,
      invoicing: false,
      statistics: false,
      news: false,
      personalCoachingBanner: false,
      faq: true,
      chatTemplates: false,
      mindfieldBranding: false,
      // Feelen asked for the support chat to be hidden entirely; instead of
      // hiding it, the AI FAQ assistant now answers first (Tabita/Barbara, 2026-08-26).
      aiAssistant: true,
    },
    support: {
      // TODO(feelen): temporarily reusing Mindfield's support account until
      // Feelen has its own Firestore `users` document with role 'supervisor'.
      // New users get this id auto-added to allowedSupervisors, and the
      // support-chat widget resolves its receiver from that list, so Feelen
      // end users currently land in Mindfield's support queue, not Feelen's.
      // neurofeedback@feelen.com
      defaultSupervisorId: '2781523',
      defaultSuperUserProfile: {
        id: '18212744',
        name: 'Mindfield',
        displayName: 'Mindfield',
        email: 'info@mindfield-biosystems.com',
      },
    },
  },
};

export const DEFAULT_TENANT_ID = 'mindfield';
